<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles approvalComments">
            <van-overlay :show="loadingShow" @click="show = false">
                <van-loading type="spinner" color="#fff"></van-loading>
            </van-overlay>
            <van-nav-bar
                title="审批意见"
                left-text="审批办理"
                left-arrow
                v-if="isNews != true"
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section :class="{'isNews': isNews}">
                <div class="roleApproval">
                    <h4>{{ submitObj.name }}</h4>
                    <div class="commonLabels" v-if="isShowCommonLanguage">
                        <span>常用标签：</span>
                        <van-button
                            plain
                            type="info"
                            size="small"
                            @click="commonWords('Approval', '同意')"
                        >
                            同意
                        </van-button>
                        <van-button
                            plain
                            type="info"
                            size="small"
                            @click="commonWords('Approval', '不同意')"
                        >
                            不同意
                        </van-button>
                    </div>
                    <van-field
                        rows="2"
                        autosize
                        type="textarea"
                        maxlength="80"
                        v-model="approvalOpinion"
                        class="iconfont iconbeizhu textarea"
                        placeholder="请输入审批意见"
                    ></van-field>
                </div>
                <div class="associatedRoleApproval" v-if="associatedRoles.name != ''">
                    <h4>{{ associatedRoles.name }}</h4>
                    <div class="commonLabels" v-if="isShowCommonLanguage">
                        <span>常用标签：</span>
                        <van-button
                            plain
                            type="info"
                            size="small"
                            @click="commonWords('relatedApproval', '同意')"
                        >
                            同意
                        </van-button>
                        <van-button
                            plain
                            type="info"
                            size="small"
                            @click="commonWords('relatedApproval', '不同意')"
                        >
                            不同意
                        </van-button>
                    </div>
                    <van-field
                        rows="2"
                        autosize
                        type="textarea"
                        maxlength="80"
                        v-model="relatedApprovalOpinion"
                        class="iconfont iconbeizhu textarea"
                        placeholder="请输入审批意见"
                    ></van-field>
                </div>
            </section>
            <div class="commonFormBtns" v-if="isPreservation == true">
                <button @click="preservation">
                    保存
                </button>
            </div>
            <van-popup
                v-model="userListShow"
                round
                position="bottom"
                :style="{ height: '30%' }"
            >
                <van-picker
                    show-toolbar
                    title="选择角色"
                    :columns="userNmaeList"
                    :default-index="0"
                    @cancel="deselect"
                    @confirm="confirmSelection"
                ></van-picker>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'approval-comments',
    components: {},
    props: {},
    data() {
        return {
            currentBusinessProcess: {},
            // 审批数据
            approvalData: {},
            // 提交对象
            submitObj: {
                name: '',
                id: '',
            },
            // 意见
            approvalOpinion: '',
            // 关联角色
            associatedRoles: {
                name: '',
                id: '',
            },
            // 关联角色意见
            relatedApprovalOpinion: '',
            // 是否显示常用语
            isShowCommonLanguage: false,
            // 当前用户下角色name集合
            userNmaeList: [],
            // 当前用户下角色id集合
            userIdList: [],
            userRoleIDList: [],
            // 角色弹出层状态
            userListShow: false,
            // 加载中状态
            loadingShow: false,
            // 是否可保存
            isPreservation: true,
            // 是否是消息跳转审批
            isNews: false,
            newsToken: '',
            // 历史消息记录
            opinionRecord: {},
        };
    },
    computed: {},
    watch: {
        approvalOpinion(val) {
            this.relatedApprovalOpinion = val;
        },
    },
    created() {
        this.isNews = this.$route.params.isNews;
        this.currentBusinessProcess = this.$route.params.currentBusinessProcess;
        // 读取父页面审批数据
        this.approvalData = this.$route.params.approvalData;
        this.newsToken = this.$route.params.thisToken;
        this.opinionRecord = this.$route.params.opinionRecord;
        // 处理用户角色数据
        this.getUserRoleData();
        if (Object.keys(this.opinionRecord).length > 0) {
            this.submitObj.id = this.opinionRecord.role_code;
            this.submitObj.name = this.opinionRecord.role_name;
        }
        // 拉取审批意见
        this.getApprovalComments(this.submitObj.id, 'Approval');
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 处理用户角色数据
        getUserRoleData() {
            this.userNmaeList = this.$takeTokenParameters('RoleNames').split(',');
            this.userIdList = this.$takeTokenParameters('RoleCodes').split(',');
            this.userRoleIDList = this.$takeTokenParameters('RoleIds').split(',');
            this.userIdList.forEach((item, index) => {
                if (item === 'J80-01') {
                    this.userNmaeList.splice(index, 1);
                    this.userIdList.splice(index, 1);
                }
            });
            this.submitObj.name = this.userNmaeList[0];
            this.submitObj.id = this.userIdList[0];
            if ((this.currentBusinessProcess.ApproverRoleId || '') !== '') {
                const NewIndex = this.userRoleIDList.findIndex(item => item === this.currentBusinessProcess.ApproverRoleId);
                if (NewIndex > -1) {
                    this.submitObj.id = this.userIdList[NewIndex];
                    this.submitObj.name = this.userNmaeList[NewIndex];
                }
            }
            this.getRelationApprovalComments(this.submitObj.id);
        },
        // 取消选择角色
        deselect() {
            this.userListShow = false;
        },
        // 确认选择色
        async confirmSelection(value, index) {
            this.submitObj.name = value;
            this.submitObj.id = this.userIdList[index];
            this.userListShow = false;
            this.saveExecution();
        },
        // 常用标签按钮
        commonWords(type, val) {
            if (type === 'Approval') {
                this.approvalOpinion = this.approvalOpinion + val;
            } else if (type === 'relatedApproval') {
                this.relatedApprovalOpinion = this.relatedApprovalOpinion + val;
            }
        },
        // 拉取审批意见
        async getApprovalComments(id, type) {
            const res = await this.getApprovalCommentsRequest(id);
            if (res) {
                if (type === 'Approval') {
                    this.approvalOpinion = res.opinion;
                } else if (type === 'relatedApproval') {
                    this.relatedApprovalOpinion = res.opinion;
                }
            }
        },
        // 拉取关联角色意见
        async getRelationApprovalComments(role_code) {
            const res = await this.getRelationApprovalCommentsRequest(role_code);
            if (res) {
                this.isShowCommonLanguage = res.is_show_common_language;
                this.associatedRoles.name = res.sync_role_names;
                this.associatedRoles.id = res.sync_role_codes;
                this.getApprovalComments(res.sync_role_codes, 'relatedApproval');
            }
        },
        // 保存评论
        async preservation() {
            if (this.approvalOpinion === '') {
                this.$toast('请输入审批意见！');
            } else if ((this.currentBusinessProcess.ApproverRoleId || '') !== '') {
                const NewIndex = this.userRoleIDList.findIndex(item => item === this.currentBusinessProcess.ApproverRoleId);
                if (NewIndex > -1) {
                    this.submitObj.id = this.userIdList[NewIndex];
                    this.submitObj.name = this.userNmaeList[NewIndex];
                    this.saveExecution();
                } else {
                    this.userListShow = true;
                }
            } else if (this.userNmaeList.length > 1) {
                this.userListShow = true;
            } else {
                this.saveExecution();
            }
        },

        // 保存执行
        async saveExecution() {
            this.loadingShow = true;
            await this.preservationRequest();
            this.loadingShow = false;
            this.$toast.success('保存成功！');
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'approvalProcess',
                params: {
                    commentsCallback: true,
                },
            });
            this.$router.go(-1);
        },

        // 拉取审批意见请求
        getApprovalCommentsRequest(id) {
            // eslint-disable-next-line max-len
            return this.$axios.$post(`/interfaceApi/basicplatform/mobile/get_opinion/${this.approvalData.BusinessCode}/${this.approvalData.BusinessInstanceId}/${id}`, {}, { token: this.newsToken });
        },

        // 拉取关联角色意见请求
        getRelationApprovalCommentsRequest(role_code) {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/second_develop/${role_code}`, { token: this.newsToken });
        },

        // 保存评论请求
        preservationRequest() {
            const data = [{
                business_code: this.approvalData.BusinessCode,
                business_instance_id: this.approvalData.BusinessInstanceId,
                business_process_id: this.approvalData.BusinessProcessId,
                opinion: this.approvalOpinion,
                role_code: this.submitObj.id,
                role_name: this.submitObj.name,
            }];
            if (this.associatedRoles.id !== '') {
                data.push({
                    business_code: this.approvalData.BusinessCode,
                    business_instance_id: this.approvalData.BusinessInstanceId,
                    business_process_id: this.approvalData.BusinessProcessId,
                    opinion: this.relatedApprovalOpinion,
                    role_code: this.associatedRoles.id,
                    role_name: this.associatedRoles.name,
                });
            }
            return this.$axios.$post('/interfaceApi/basicplatform/mobile/add_opinion', data, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.approvalComments
    height 100%
    position relative
    .van-loading
        position absolute
        top 50%
        left 50%
        z-index 9
        transform translate(-50% , -50%)
    section
        height: calc(100% - 104rpx)
        background: #fff
        &.isNews
            height: calc(100% - 60rpx)
        div
            overflow hidden
        h4
            font-size 14rpx
            color #0285FE
            line-height 16rpx
            padding 0 15rpx 0 40rpx
            margin-top 13rpx
            background url('../../../assets/images/contractApproval/icon1.png')
            background-position 15rpx center
            background-repeat no-repeat
            background-size 10rpx 10rpx
        .commonLabels
            padding 0 15rpx
            margin-top 13rpx
            >span
                font-size 14rpx
                color #979EA7
            .van-button
                margin-right 20rpx
        .textarea
            padding 0 15rpx
            margin-top 13rpx
            position relative
            &:before
                position absolute
                top 6rpx
                left 26rpx
            textarea
                text-indent 25rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 5rpx 10rpx
                    height 130rpx !important
</style>